import { Component,OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { Constant,BaseComponent} from 'app/infrastructure/common/index';
import { OnlineShippingNoticeService } from 'app/infrastructure/services/transaction/op/inbound/asn/online-shipping-notice.service';
import { AdvancedShippingNotice} from 'app/data/models/transaction/op/inbound/asn';

enum StepPage {
    ChooseAccount = 1,
    FillInfo,
    SelectProducts,
    ASNSummary
}

@Component({
    selector: 'app-submit-asn',
    templateUrl: './submit-asn.html'
})
export class SubmitAsnComponent extends BaseComponent implements OnInit {
    stepPage = StepPage;
    selectedStepPage: StepPage;
    
    ownerCode: string;
    asn:AdvancedShippingNotice;
    isFromList:boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private onlineShippingNoticeService : OnlineShippingNoticeService){
        super();
    }

    ngOnInit(): void {
        let self = this;
        self.ownerCode = null;

        self.route
            .queryParams
            .subscribe(params => {
                if (Object.keys(params).length > 0) {
                    if(params['ownerCode'] != null && params['asnNo'] != null)
                        self.loadData(params['ownerCode'],params['asnNo']);
                    else
                        self.selectedStepPage = self.stepPage.ChooseAccount;
                }else{
                    self.selectedStepPage = self.stepPage.ChooseAccount;
                }
            });
    }

    loadData(ownerCode:string,asnNo:string): void {
        let self = this;
        self.onlineShippingNoticeService.requestGetAsn(ownerCode,asnNo,self.token.DateFormatDescription)
            .subscribe(
            data => {
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        self.isFromList = true;
                        self.ownerCode = ownerCode;
                        self.asn = message.Result;
                        
                        if(message.Result.OnlineShippingNoticeServices){
                            let newData = [];
                            message.Result.OnlineShippingNoticeServices.forEach(function (item) {
                                let additionalService = {
                                    Id: item.BlContractDId,
                                    ChargeCode: item.ChargeCode
                                }

                                if (additionalService) {                                    
                                    newData.push(additionalService);
                                }
                            });

                            self.asn.OnlineShippingNoticeServices = newData;
                        }

                        self.selectedStepPage = self.stepPage.FillInfo;
                    }
                    else {
                        //self.showAlert(message.MessageType.Value, message.MessageNumber, message.Message, message.AdditionalInformation);
                    }
                }
                else {
                    //self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, null);
                }
            },
            error => {
                //self.isLoadingTranscode = false;
                //self.showAlert(Constant.MessageType.error, Constant.MessageNumber.defaultError, Constant.Message.defaultError, error);
            });
    }

    fillInfo(ownerCode: string){
        this.asn = new AdvancedShippingNotice();
        this.selectedStepPage = this.stepPage.FillInfo;
        this.ownerCode = ownerCode;
    }

    selectProducts(asn:AdvancedShippingNotice){
        this.selectedStepPage = this.stepPage.SelectProducts;
        this.asn = asn;
    }

    asnSummary(asn:AdvancedShippingNotice){
        this.selectedStepPage = this.stepPage.ASNSummary;
        this.asn = asn;
    }

    goToFirst(){
        if(!this.isFromList){
            this.ownerCode = null;
            this.asn = new AdvancedShippingNotice();
            this.selectedStepPage = this.stepPage.ChooseAccount;
        }else
            this.router.navigate(['pages/asn-list']);
    }
    goBack() {
        if(this.isFromList && (this.selectedStepPage == this.stepPage.FillInfo))
            this.router.navigate(['pages/asn-list']);
        else
            this.selectedStepPage -= 1;
    }
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/inbound/asn/submit-asn/submit-asn.component.ts